import { StatusBadge } from "@/components/status-badge";
import type { StatusBadgeTone, StatusKey } from "@/components/status-badge";

type RunStatus = "pending" | "processing" | "completed" | "failed" | undefined;

const runStatusConfig: Record<
  string,
  { status: StatusKey; label: string; tone?: StatusBadgeTone; showSpinner?: boolean }
> = {
  pending: { status: "pending", label: "Queued", showSpinner: true },
  processing: { status: "processing", label: "Indexing", showSpinner: true },
  completed: { status: "completed", label: "Indexed", showSpinner: false },
  failed: { status: "error", label: "Failed", showSpinner: false },
  undefined: {
    status: "pending",
    label: "Not Indexed",
    tone: "muted",
    showSpinner: false,
  },
};

export function RunStatusBadge({ status }: { status: RunStatus }) {
  const config = runStatusConfig[String(status)] ?? runStatusConfig.undefined;

  return (
    <StatusBadge
      status={config.status}
      label={config.label}
      tone={config.tone}
      showSpinner={config.showSpinner}
    />
  );
}
